module.exports = __webpack_public_path__ + "static/Bessemer-6bd86a19c674a20f71eb243bc1287d23.png";